<a
  mat-list-item
  (click)="navigateTo(vm.navPath)"
  *ngIf="vm.showCond"
  [class.selected]="isSelected"
  [matTooltip]="
    collapsed ? (vm.titleReplaceMap ? (vm.titleKey | locRep: vm.titleReplaceMap) : (vm.titleKey | loc)) : ''
  "
>
  <div class="icon">
    <mat-icon>{{ vm.icon }}</mat-icon>
    <app-new-info *ngIf="showNtf" [amount]="ntfAmount" [size]="15"></app-new-info>
  </div>
  <span *ngIf="!collapsed">
    {{ vm.titleReplaceMap ? (vm.titleKey | locRep: vm.titleReplaceMap) : (vm.titleKey | loc) }}
  </span>
</a>
